import { useMutation, useQueryClient } from '@tanstack/react-query';

import personalizationKeys from '../../hooks/personalization/_queryKeys';

// constants
import API from '../../services/api';

import alternateKeys from '../alternates/_queryKeys';
// queryKeys
import formulaKeys from '../formulas/_queryKeys';
// hooks
import useAnalytics from '../helper/useAnalytics';
import useGetCurrentMessageContent from '../message-content/useGetCurrentMessageContent';

export default function useAddLabeltoVariantMutation(
    formulaId: number,
    variantId: string,
    messageContentID?: string,
) {
    const queryClient = useQueryClient();
    const { currentMessageContentId: hookMessageContentId } =
        useGetCurrentMessageContent(formulaId);
    const messageContentId = messageContentID ?? hookMessageContentId;

    const { track } = useAnalytics();

    return useMutation({
        mutationFn: API.addLabeltoVariant,
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: alternateKeys.getVariantsByComponentId(variantId),
            });
            queryClient.invalidateQueries({
                queryKey: alternateKeys.getVariantsByMessageContentId(
                    messageContentId as string,
                ),
            });
            queryClient.invalidateQueries({
                queryKey: ['personalization-map'],
            });

            queryClient.invalidateQueries({
                queryKey: personalizationKeys.unlabelledVariants,
            });
            queryClient.invalidateQueries({
                queryKey: personalizationKeys.getHeroRecommendations(),
            });
            track('personalization_label_added', {
                formula_id: formulaId,
                variant_id: variantId,
            });
            queryClient.invalidateQueries({
                queryKey: [
                    ...formulaKeys.formulaLabelAlternateCount(formulaId),
                ],
            });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.formulaMessages(
                    formulaId,
                    messageContentId,
                ),
            });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.formulaMessageCountUpdate(formulaId),
            });
        },
    });
}
